import { Typography } from '@mui/material';
import styled from 'styled-components';

import TextField from '../TextField';

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledSignIn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GuideTitle = styled(Typography)`
  && {
    color: ${({ theme }) => (theme.palette.darkPrimary.main)};
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    font-weight: bold;
    text-align: center;
  }
`;

const GuideBody = styled(Typography)`
  text-align: center;
`;

const GuideTextContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  margin: ${({ theme }) => theme.spacing(2)};
  && {
    width: 320px
  };
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin: ${({ theme }) => theme.spacing(2)};
`;

const FooterText = styled(Typography)`
  && {
    color: ${({ theme }) => (theme.palette.gray.main)};
  }
`;

const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export { StyledSignIn,
  QRCodeContainer,
  GuideTitle,
  GuideBody,
  GuideTextContainer,
  FormContainer,
  ButtonContainer,
  StyledTextField,
  FooterText };
